import { apiCall } from './gqlClient';

const NOTIFYNEWCHATMESSAGE_QUERY = `
  mutation notifyNewChatMessage($chatId: String!) {
    notifyNewChatMessage(chatId: $chatId)
    {
      sent
      ...fragments
    }
  }`;

export const notifyNewChatMessageApiCall = async ({chatId}, fragments = null) => apiCall({ query: NOTIFYNEWCHATMESSAGE_QUERY, variables: {chatId}, fragments });

const NOTIFYNEWCHANNELMESSAGE_QUERY = `
  mutation notifyNewChannelMessage($channelId: String!) {
    notifyNewChannelMessage(channelId: $channelId)
    {
      sent
      ...fragments
    }
  }`;

export const notifyNewChannelMessageApiCall = async ({channelId}, fragments = null) => apiCall({ query: NOTIFYNEWCHANNELMESSAGE_QUERY, variables: {channelId}, fragments });
